import React, { useEffect, useState } from 'react';

const STORAGE_KEY = 'cookiesAccepted';

/**
 * Compact bottom-right cookie consent toast.
 * Stores the user choice in localStorage so it never reappears once dismissed.
 * Two choices recorded: "all" (accept all) and "necessary" (only essential).
 */
const CookiesPolicy = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show only if no prior choice has been made.
    if (!localStorage.getItem(STORAGE_KEY)) {
      // Slight delay so the toast slides in after the page settles.
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const persist = (choice) => {
    localStorage.setItem(STORAGE_KEY, choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Setari cookies"
      className="fixed bottom-4 right-4 z-50 w-[min(92vw,360px)] bg-white border border-slate-200 rounded-xl shadow-2xl overflow-hidden"
      style={{
        animation: 'cookieToastIn 0.35s cubic-bezier(0.2, 0.9, 0.3, 1)',
      }}
    >
      <style>{`
        @keyframes cookieToastIn {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <button
        onClick={() => persist('necessary')}
        aria-label="Inchide"
        className="absolute top-2 right-2 w-7 h-7 flex items-center justify-center text-slate-400 hover:text-slate-700 hover:bg-slate-100 rounded-md transition"
      >
        <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
          <path
            fillRule="evenodd"
            d="M4.28 4.22a.75.75 0 011.06 0L10 8.94l4.66-4.72a.75.75 0 111.07 1.06L11.07 10l4.66 4.72a.75.75 0 11-1.07 1.06L10 11.06l-4.66 4.72a.75.75 0 11-1.07-1.06L8.93 10 4.28 5.28a.75.75 0 010-1.06z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      <div className="p-4 pr-10">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-lg" aria-hidden>🍪</span>
          <h2 className="text-sm font-semibold text-slate-800">
            Cookies pe Licitatii-Constructii
          </h2>
        </div>

        <p className="text-xs text-slate-600 leading-relaxed">
          Folosim cookies esentiale pentru autentificare si cookies analitice
          pentru a imbunatati platforma. Poti accepta toate sau doar pe cele
          necesare functionarii.
        </p>

        <div className="mt-3 flex flex-col gap-2">
          <button
            onClick={() => persist('all')}
            className="w-full px-3 py-2 bg-indigo-600 text-white text-xs font-semibold rounded-lg hover:bg-indigo-700 transition shadow-sm"
          >
            Accept toate
          </button>
          <button
            onClick={() => persist('necessary')}
            className="w-full px-3 py-2 bg-white border border-slate-300 text-slate-700 text-xs font-medium rounded-lg hover:bg-slate-50 transition"
          >
            Doar necesare
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookiesPolicy;
